// Curated product imagery supplied by the client, keyed by product slug.
// Used for commercial / line-marking products whose photos are not stored as
// remote URLs in the database.
import titanHero from "@/assets/titan-hero.jpg";
import titanThreeQuarter from "@/assets/titan-three-quarter.webp";
import titanSlope from "@/assets/titan-slope.webp";
import titanTech from "@/assets/titan-tech.webp";
import comboInAction from "@/assets/combo-in-action.jpeg";
import proHero from "@/assets/pro-hero.jpg";
import proEfficiency from "@/assets/pro-efficiency.jpg";
import proSoftware from "@/assets/pro-software.jpg";
import proSafety from "@/assets/pro-safety.jpg";
import paintSupernova from "@/assets/paint-supernova-can.webp";
import paintMarker from "@/assets/paint-marker.png";
import miniLineMarking from "@/assets/mini-line-marking.jpg";
import miniThreeQuarter from "@/assets/mini-three-quarter.png";
import miniSide from "@/assets/mini-side.png";
import miniEyeLevel from "@/assets/mini-eye-level.png";
import miniProductView from "@/assets/mini-product-view.webp";
import frxHero from "@/assets/frx-hero.webp";
import frxGolf from "@/assets/frx-golf.webp";
import frxMultiField from "@/assets/frx-multi-field.png";
import frxDayNight from "@/assets/frx-day-night.webp";
import frxAppControl from "@/assets/frx-app-control.jpg";

export const PRODUCT_IMAGES = {
  "fjd-titan": [titanHero, titanThreeQuarter, titanSlope, titanTech],
  "fjd-titan-line-marker-combo": [comboInAction, titanThreeQuarter, titanSlope],
  "fjd-frx": [frxHero, frxGolf, frxMultiField, frxDayNight, frxAppControl],
  "paintmaster-pro": [proHero, proEfficiency, proSoftware, proSafety],
  "paintmaster-mini": [miniLineMarking, miniThreeQuarter, miniSide, miniEyeLevel, miniProductView],
  "baufan-supernova": [paintSupernova, paintMarker],
  "spectro-442": [paintMarker, paintSupernova],
};

export function getProductImages(slug) {
  return PRODUCT_IMAGES[slug] || [];
}
